import { render, staticRenderFns } from "./resourceManageSignDialog.vue?vue&type=template&id=98cf1e8c&scoped=true"
import script from "./resourceManageSignDialog.vue?vue&type=script&lang=js"
export * from "./resourceManageSignDialog.vue?vue&type=script&lang=js"
import style0 from "./resourceManageSignDialog.vue?vue&type=style&index=0&id=98cf1e8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cf1e8c",
  null
  
)

export default component.exports